import React from 'react';
import { Card } from '@tribeplatform/react-ui-kit/Card';
export const LoadingComponent = () => {
    return (React.createElement(Card, null,
        React.createElement(Card.Content, null,
            React.createElement("div", { className: "animate-pulse" },
                React.createElement("div", { className: "flex-1 space-y-4 py-1" },
                    React.createElement("div", { className: "h-6 bg-skeleton rounded-full w-1/4" }),
                    React.createElement("div", { className: "space-y-2" },
                        React.createElement("div", { className: "h-4 bg-skeleton rounded-full" }),
                        React.createElement("div", { className: "h-4 bg-skeleton rounded-full w-5/6" }),
                        React.createElement("div", { className: "h-4 bg-skeleton rounded-full" }),
                        React.createElement("div", { className: "h-4 bg-skeleton rounded-full w-5/6" }),
                        React.createElement("div", { className: "h-4 bg-skeleton rounded-full" }),
                        React.createElement("div", { className: "h-4 bg-skeleton rounded-full w-5/6" }),
                        React.createElement("div", { className: "h-4 bg-skeleton rounded-full" })))))));
};
//# sourceMappingURL=LoadingComponent.js.map